import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export const CheckIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 9 7">
    <path
      d="M1 2.5L3.48387 5L8 1"
      strokeLinecap="round"
      strokeWidth={1.5}
      fill="transparent"
    />
  </SvgIcon>
);
